import { Action } from 'store';
import { Types } from '.';

export interface State {
  selected: {
    rulesetId: string;
    ruleIndex: number;
    stepName: string;
  };
  rulesetsToDelete: string[];
}

const initialState: State = {
  selected: {
    rulesetId: undefined,
    ruleIndex: undefined,
    stepName: undefined,
  },
  rulesetsToDelete: [],
};

export const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case Types.DISCARD_CHANGES:
      return {
        ...state,
        rulesetsToDelete: [],
      };

    case Types.DELETE_RULESET:
      return {
        ...state,
        rulesetsToDelete: [...state.rulesetsToDelete, action.payload.rulesetId],
      };

    case Types.CLEAR_RULESET:
      return {
        ...state,
        rulesetsToDelete: [],
      };

    default:
      return state;
  }
};
